//import ReactToPdf from "react-to-pdf";
import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import Cookies from "universal-cookie";
import Moment from "moment";
import logo from "./images/loading.gif";
import modallogo from "./images/loader.gif";
import paidimage from "./images/paid.jpg";
import logoverified from "./images/verified.png";
import Mymodal from './modal';
import config from '../config';
import logonorecord from "./images/recordnotfound.png";
import CanvasJSReact from '@canvasjs/react-charts';

const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default class AdminMedicalFormList extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
            apipath:"",
            myitems: [],
            mylist:[],
            isOpen:false,
            modalimage:modallogo,
            isLoaded: true,
            isList: "none",
            isForm:"none",
            FormID:"",
            EmpID:"",
            errortext:"",
            EmpName:"",
            Ceiling:0,
            Remaining:0,
            paidlogo:"",
            dataPoints:[],
            bformlogo:"",
            divbutton:"<button onClick={this.handleVerify(0)} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}}>Check / Verify</button>",
            ErrMsg:"" //<img src={logo} alt=""/>,
        }
        this.currencyFormat = this.currencyFormat.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.handleGetForm = this.handleGetForm.bind(this);
      }
    componentDidMount(){
        this.setState({apipath:this.props.apipath});
    }
    handleClick(){

    }
      // handle input change
    handleInputChange = (e)=> {
        this.setState({EmpID:e.target.value});
    }
  handleFocus(event){event.target.select();}
  
  handleVerify(){
    document.body.style.cursor="wait";
    this.setState({buttonED:true,isOpen:true});
    axios({
        method: "post",
//        url:    cookies.get("phpclass")+'/index.php/user/approveMedical/'+this.state.FormID,
        url:    this.state.apipath+'/index.php/user/approveMedical/'+this.state.FormID,
        heaer: {"Content-Type":"multipart/for-data"}
    })
    .then((response)=>{
        document.body.style.cursor="default";
        this.setState({buttonED:true,divbutton:<img src={logoverified}/>,isOpen:false});

    })
    .catch=()=>{
        document.body.style.cursor="default";
        this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>,isOpen:false});

    };

  }
    currencyFormat(num) {
        let cnum=Number(num);
        return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
     }
    handleSubmit(){

        if(this.state.EmpID.length < 2)
        {  
            this.setState({errortext:"Invalid Employee ID",mylist:[],myitems:[],isList:"none",isForm:"none"});
        }
        else
        {        
            document.body.style.cursor="wait";
            this.setState({errortext:"",ErrMsg:<img src={logo} alt=""/>,mylist:[],myitems:[],isList:"none",isForm:"none"});
        axios.all([
            axios({
                method: 'post',
//                url: cookies.get("phpclass")+'/index.php/user/medicallist/'+this.state.EmpID,
                url: this.state.apipath+'/index.php/user/medicallist/'+this.state.EmpID,
                headers: {'Content-Type': 'multipart/form-data'}
            }),
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/medicalchart/'+this.state.EmpID,
                headers: {'Content-Type': 'multipart/form-data'}
            }),            
        ])
            .then(axios.spread((response,res2)=> {
                if(response.data.length == 0)
                {
                    this.setState({errortext:"Invalid Employee ID",ErrMsg:<img src={logonorecord} alt=""/>});
                    document.body.style.cursor="default";
                }
                else
                {
                    document.body.style.cursor="default";
                    this.setState({
                    isLoaded: true,
                    ErrMsg:"",
                    isList: "block",
                    isForm: "none",
                    EmpName:response.data[0]["Name"],
                    Ceiling:response.data[0]["ceiling"],
                    Remaining:response.data[0]["remaining"],
                    bformlogo:response.data[0]["imagename"],
                    mylist: response.data
                    });
                    var dps = [];
                    var myear;
                    for (var i = 0; i < res2.data.length; i++) {
                        myear=res2.data[i].mYear.toString();
                        dps.push({
                            label: res2.data[i].mmonth.toString()+", "+myear,
                            y: Number(res2.data[i].Totamt)
    //                        label:data[i].cmonth
                            
                        });
                    }
                    console.log(dps);
                    this.setState({dataPoints: dps});
    
                }
            }))
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<img src={logo} alt=""/>});
            });  
        }

    }

    handleGetForm(ClaimId){
        document.body.style.cursor="wait";
        axios({
            method: 'post',
//            url: cookies.get("phpclass")+'/index.php/user/Adminmedicalform/'+ClaimId,
            url: this.state.apipath +'/index.php/user/Adminmedicalform/'+ClaimId,
            headers: {'Content-Type': 'multipart/form-data'}
            })
           .then((response)=> {
                document.body.style.cursor="default";
                let input = this.state.input;
                input["Name"] = response.data[0]["NAME"];
                input["Designation"] = response.data[0]["DESIG"];
                input["Emp_ID"] = response.data[0]["Emp_Id"];
                input["Location"] = response.data[0]["location"];
                input["Company_Name"] = response.data[0]["company_name"];
                input["DateClaim"] = response.data[0]["DateClaim"];
                input["ClaimID"] = ClaimId;
                this.setState({input, isForm: "block", myitems: response.data, ErrMsgs:"",FormID:ClaimId});
                if(response.data[0]['status'] === 1)
                    this.setState({paidlogo:paidimage, divbutton:<span style={{fontSize:'12pt',color:'red'}}>This claim has already been paid.</span>});
                else
                    this.setState({paidlogo:"",divbutton:<button onClick={this.handleVerify} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}}>Check / Verify</button>});
                })
            .catch=()=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            }; 
    }
    render(){
        console.log(this.state.bformlogo);
        let fileName=this.state.input["ClaimID"]+"-medical.pdf";
        let items=this.state.myitems;
        let mylist=this.state.mylist;
        let CDate,MDate,TDate = "";
        let CAmt = 0;
        let MAmt = 0;
        let TAmt = 0;
        let isLoaded = this.state.isLoaded;
        let isList = this.state.isList;
        let isForm = this.state.isForm;
        let imageurl=this.state.bformlogo;
        const options = {
            animationEnabled: true,
            exportEnabled: false,
            theme: "light2", //"light1", "dark1", "dark2"
            title:{
                text: "Month wise"
            },
            axisY: {
                includeZero: true
            },
            data: [{
                type: "line", //change type to bar, line, area, pie, etc
                indexLabel: "Rs. {y}", //Shows y value on all Data Points
                indexLabelFontColor: "#5A5757",
                indexLabelPlacement: "outside",
                dataPoints: this.state.dataPoints
            }]            
    }

        if(isLoaded)
        {
            return (
                <div width="100%" align="center" >
                <br></br>
                <div className="inner-profile33" >

                <div className="inner-profile2" >
                    <label>Employee Id: </label>
                    <input style={{width:"110px",paddingRight:20}} autoFocus="autofocus" name="EmpID" placeholder="Employee Id" onChange={this.handleInputChange} onFocus={ this.handleFocus}/>
                    <button onClick={this.handleSubmit} >Submit</button>
                    <span className="labelerror">{this.state.errortext}</span>
                </div>
    
{/*}            <div width="100%" Align="center" style={{display:isList}} >  */}
{/*}            <img src={this.state.bformlogo} style={{width:"50px", height:"75px", float:"right",cursor:"pointer"}} onClick={() => window.open(this.state.bformlogo, "_blank")}  />*/}
            <img src={this.state.bformlogo} style={{width:"50px", height:"75px", float:"right",cursor:"pointer"}} data-bs-toggle="modal"  data-bs-target="#imageModal2" />
            <div class="modal fade" id="imageModal2">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-body text-center">
                            <img src={this.state.bformlogo} class="img-fluid" alt="Form Logo" />
                        </div>
                    </div>
                </div>
            </div>

    <div style={{width:"100%",display:isList}} >  
            <table style={{width:"100%"}}>
            <thead>
            <tr >
                <th style={{border:0}} >Name:</th>
                <th style={{border:0}}  colSpan={3}>{this.state.EmpName}</th>
            </tr>
            <tr >
                <th style={{border:0}} scope="col">Ceiling:</th>
                <th style={{border:0}} scope="col" colSpan={3}>{this.currencyFormat(this.state.Ceiling)}</th>
            </tr>
            <tr >
                <th style={{border:0}} scope="col">Remaining:</th>
                <th style={{border:0}} scope="col" colSpan={3}>{this.currencyFormat(this.state.Remaining)}</th>
            </tr>


            <tr className="tr">
                <th className="thm" scope="col">Claim ID</th>
                <th className="thm" scope="col">Claim Data</th>
                <th className="thm" scope="col">Amount</th>
                <th className="thm" scope="col"></th>
            </tr>
            </thead>
            <tbody>
            {mylist.map((result ,i)=>{
                return(
                    <tr className="trc" key={i}>
                        <td className="tdm" >{result.ClaimID}</td>
                        <td className="tdm">{result.ClaimDate}</td>
                        <td className="tdm">{result.TotalAmt}</td>
                        <td className="tdm" ><button type="button"  onClick={() => {this.handleGetForm(result.ClaimID)}}>View</button>
                        </td>
                    </tr>
                )
              })}
            </tbody>
        </table>

        <div style={{textAlign:"center",marginTop:"10px",width:"100%",margin:"auto",paddingBottom:"10px", display:isList}}>

            <CanvasJSChart options={options} containerProps={{ width: '100%', height: '300px' }}/>
            <br></br>

        </div>
        </div>


        </div>
<br></br>
                <div width="100%" align="center" style={{display:isForm}}>
                <div className="inner-profile33">
                <table style={{ width:"100%",  margin:"0 auto"}} id="DReport" name="DReport"  ref={ref}>                <tr >

                <div width="100px"  >
                    <div style={{width:"60%", float:"left"}}>
                   <h4>{this.state.input["Company_Name"]}</h4>
                    <h5>Medical Reimbursement Form</h5>

                    <h6>
                    <table className="mtable">
                        <tbody>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Claim ID:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:12}}>{this.state.input["ClaimID"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Employee's ID:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:12}}>{this.state.input["Emp_ID"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Employee's Name:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:12}}>{this.state.input["Name"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Designation:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:12}}>{this.state.input["Designation"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Location:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:12}}>{this.state.input["Location"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Date:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:12}}>{Moment(this.state.input["DateClaim"]).format("DD/MM/YYYY")}</td>
                        </tr>
                        </tbody>
                    </table>
                    </h6>  
                    </div>
                    <div style={{width:"40%", float:"left"}}>
                        <img src={this.state.paidlogo} />

                    </div>
                    <table className="mtable">
                        <thead >
                            <tr>
                                <th className="mth" rowSpan="2" ><p style={{textAlign:'left'}}>PATIENT NAME</p></th>
                                <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>RELATION</p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>CONSULTATION</p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>MEDICINES </p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>TESTS/LAB.</p></th>
                                <th className="mth" colSpan="2" rowSpan="2"><p style={{textAlign:'center'}}>TOTAL</p></th>
                            </tr> 
                            <tr>
                                <th className="mth" >Amount</th>
                                <th className="mth">Date</th>
                                <th className="mth">Amount</th>
                                <th className="mth">Date</th>
                                <th className="mth">Amount</th>
                                <th className="mth">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((x, i) => {
                            CAmt += Number(x.Const_amt);
                            TAmt += Number(x.Test_amt);
                            MAmt += Number(x.Med_amt);

                            if(Number(x.Const_amt) === 0) 
                                CDate= "-";
                            else
                                CDate=Moment(x.Const_date).format("DD/MM/YYYY")
                            if(Number(x.Med_amt) === 0) 
                                MDate= "-";
                            else
                                MDate=Moment(x.Med_date).format("DD/MM/YYYY")
                            if(Number(x.Test_amt) === 0) 
                                TDate= "-";
                            else
                                TDate=Moment(x.Test_date).format("DD/MM/YYYY")
                                return(
                                    <tr key={i} height="40px">
                                        <td className="mtdleft" >
                                            {x.PName}
                                        </td>
                                        <td className="mtdcenter">
                                            {x.Relation}
                                        </td>
                                        <td className="mtdright" >
                                            {this.currencyFormat(x.Const_amt)}                
                                        </td>
                                        <td className="mtdcenter">
                                            {CDate}
                                        </td>
                                        <td className="mtdright" >
                                            {this.currencyFormat(x.Med_amt)}
                                        </td>
                                        <td className="mtdcenter">
                                            {MDate}
                                        </td>
                                        <td className="mtdright">
                                            {this.currencyFormat(x.Test_amt)}
                                        </td>
                                        <td className="mtdcenter">
                                            {TDate}
                                        </td>
                                        <td className="mtdright">
                                            {this.currencyFormat(Number(x.Const_amt)+Number(x.Med_amt)+Number(x.Test_amt))}
                                        </td>
                                    </tr>
                                );
                                })}            
                        </tbody>
                        <tr style={{height:"40px", border: "1.5px solid rgb(161, 159, 159)"}}>
                            <td className="mtdleft2" colSpan="2">
                                TOTAL
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(CAmt)}                
                            </td>
                            <td className="mtdcenter2" colSpan="2" >
                                {this.currencyFormat(MAmt)}
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(TAmt)}
                            </td>
                            <td className="mtdright2" colSpan="3">
                                {this.currencyFormat(Number(CAmt)+Number(MAmt)+Number(TAmt))}
                            </td>
                        </tr>
                        <tr height="40px"></tr>
                        <tr height="170px">
                            <td className="mtdcenterH" rowSpan="10" colSpan="3">REQUESTED BY</td>
                            <td className="mtdcenterH" rowSpan="10" colSpan="3">CHECKED BY</td>
                            <td className="mtdcenterH" rowSpan="10" colSpan="3">APPROVED BY</td>
                        </tr> 
                    </table>
                    <div><p className="Pclass">
                        Please attach all original Doctor's prescriptions and receipt.</p>
                        <p className="Pclass">
                        All amounts should be rounded to the nearest rupee.</p>        
                        <p className="Pclass"><b>

                        REMARKS:_____________________________________________
                        </b></p>

                        <p className="Pclass"><b>
                        For office use only:</b></p>
                    </div>
                </div>
            </tr>
            </table>
            <div align="center" width="50%" >
                {this.state.divbutton}
            </div>


    </div>
    </div>
    <br></br><br></br><br></br>
    {this.state.ErrMsg}


   </div>
    );
    }

}
}
